import { render, staticRenderFns } from "./RequestFAQ.vue?vue&type=template&id=245cdca5&scoped=true"
import script from "./RequestFAQ.vue?vue&type=script&lang=js"
export * from "./RequestFAQ.vue?vue&type=script&lang=js"
import style0 from "./RequestFAQ.vue?vue&type=style&index=0&id=245cdca5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245cdca5",
  null
  
)

export default component.exports